 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"vendors~vsf-category~vsf-checkout~vsf-cms~vsf-compare~vsf-home~vsf-my-account~vsf-product~vsf-top-ba~dee0c57b","3":"vsf-category~vsf-compare~vsf-desktop-memu~vsf-home~vsf-my-account~vsf-not-found~vsf-related~vsf-rela~610fdd32","4":"vsf-compare~vsf-desktop-memu~vsf-home~vsf-my-account~vsf-not-found~vsf-product~vsf-search-panel~vsf-~b3ee85fa","5":"vendors~vsf-category~vsf-wp-categories-show~vsf-wp-posts-index~vsf-wp-posts-show","6":"vsf-color-selector-product~vsf-color-wariant-modal~vsf-product-custom-color","7":"vsf-checkout~vsf-microcart","8":"vsf-microcart~vsf-product","9":"SwipeActions","11":"for-download","12":"lang-pl-PL-json","14":"vendors~bodybuilder","15":"vendors~vsf-category","16":"vendors~vsf-checkout","17":"vendors~vsf-graphql","18":"vendors~vsf-search-panel","19":"vsf-account-icon","20":"vsf-async-bottom-sidebar","21":"vsf-async-sidebar","22":"vsf-blog-preview-product","23":"vsf-category","24":"vsf-checkout","25":"vsf-cms","26":"vsf-color-selector-product","27":"vsf-color-wariant-modal","28":"vsf-compare","29":"vsf-compare-icon","30":"vsf-contact-modal","31":"vsf-cookie-notification","32":"vsf-desktop-memu","33":"vsf-error","34":"vsf-footer","35":"vsf-forgotpass","36":"vsf-hamburger-icon","37":"vsf-header","38":"vsf-home","39":"vsf-inner-header","40":"vsf-languages-modal","41":"vsf-layout-default","42":"vsf-login","43":"vsf-mic-icon","44":"vsf-microcart","45":"vsf-microcart-icon","46":"vsf-my-account","47":"vsf-not-found","48":"vsf-order-confirmation","49":"vsf-placepozniej","50":"vsf-product","51":"vsf-product-custom-color","52":"vsf-product-gallery-carousel","53":"vsf-product-gallery-overlay","54":"vsf-product-gallery-zoom-carousel","55":"vsf-product-info-modal","56":"vsf-product-tabs","57":"vsf-register","58":"vsf-related","59":"vsf-related-bestseller","60":"vsf-related-small","61":"vsf-reset-password","62":"vsf-search-adapter-0","63":"vsf-search-adapter-1","64":"vsf-search-panel","65":"vsf-search-panel-desktop","66":"vsf-sidebar-menu","67":"vsf-sign-up","68":"vsf-top-bar","69":"vsf-typ","70":"vsf-wishlist","71":"vsf-wishlist-icon","72":"vsf-wp-categories-index","73":"vsf-wp-categories-show","74":"vsf-wp-posts-index","75":"vsf-wp-posts-show"}[chunkId]||chunkId) + "." + {"0":"0f2d124ce70c4c5e1b2a","2":"9ba1baf84dc10dd31a9a","3":"26af2304150bf23d597e","4":"a03fe27782e28a0f2d2d","5":"cbe3297f519f785e286a","6":"5e909cfedf0d68c73a8c","7":"e329e718b122105b6ad5","8":"e36945f2b9eb5f4e24ac","9":"3fe017b4edb4b0c2d7f6","11":"d537f2758fc8add9b2ae","12":"b6ad50f87c9e19a62727","14":"942a1f012a4896277392","15":"8c0e46cfe5d24f6abc3a","16":"0d172c6424b9e3ce0afc","17":"fde176522fd0da2f1565","18":"e7e157579fea25dc3790","19":"cb8536aef72c1c178b9f","20":"828b2fc505cea356176b","21":"857defec4ffb976c824c","22":"a5555b7ce51788e151a7","23":"93363c8ff8450147fbe1","24":"b15858fe0976597f124c","25":"332e527004981a51fe20","26":"3083ceed19a051a25147","27":"371c14d10423ae5d5cd6","28":"f3d27ebecb08c873d139","29":"76ed05a91c037b6f8447","30":"d35e5048178ecb888e9d","31":"296caa39e049303d6017","32":"eb8cb19e81ab00e29b30","33":"ee3fa4aec849d55a4e72","34":"e856caee469d98712fc5","35":"361583fc0c35a87771b5","36":"d49e1a64b26dcacc0d4a","37":"7172eda6400017658f14","38":"1f3a4569a7e87834785c","39":"91e21f84c3df8f490f90","40":"a818659b78af0ecb82f4","41":"0e1837952267e7b727f7","42":"837e413210e1060a54a8","43":"0dd0df9570317fe71dee","44":"4a43053d15d6550b71cf","45":"70c4fe0fcde260bcdc2d","46":"02e4ef84495a7fedc137","47":"f0790b4536b7a84b9ff0","48":"0a447d92ed4b6a63cd9f","49":"34896ad2b08266d23212","50":"8cd3906556054723d77a","51":"58d79a3dbf6ff4cdfc43","52":"07575a0335c07d89dd34","53":"a0a58def6ee95baea25e","54":"b31e5a3809297edab515","55":"157b7e18d6fdb9e83c62","56":"cb34440b0f04a8e26f14","57":"a3d440e53c64ad60f968","58":"ab2720d506949c8de7b5","59":"5537649892b65f5d9a45","60":"9325b565edb92fb1fec7","61":"e0f2e95d9873853748b6","62":"c846221ab71b1ac448f5","63":"ac81e9382719343d95fb","64":"98cf8376d693fa625c00","65":"02b6cee61d2aed6e0bad","66":"158fb32f380c211d4e11","67":"5c64d1abfe0a911d623c","68":"0b38ff988d50f1dc854b","69":"f3e7937e42eea9898708","70":"6b655abf826b8c4f12c1","71":"71eb0bc72c2e089ba38e","72":"96b3183ffd1fba138a1b","73":"4bc22e52cf33b03f33ae","74":"0c6d6fe00fd0a0472ca7","75":"09a750677daaeb05686e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"41": [
 				1,
 				7,
 				8,
 				44,
 				3,
 				4,
 				70,
 				66
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
